import React from "react";

const Summary = () => {
  return (
    <div className="article-section">
      <div className="container">
        <ol start="65" type="1">
          <li>
            [First Name]. You have the same two issues that every Federal
            Employee has. It’s not your fault or because you did anything wrong,
            it’s just the way the system is set up.
          </li>
          <li>
            <strong className="agent-tip">
              First, you won’t have enough life insurance when you and your
              family when you need it the most
            </strong>
          </li>
          <li>
            <strong className="agent-tip">
              Second, everyone wants as much income in retirement as possible.
              Wouldn’t you agree?
            </strong>
          </li>
          <li>
            So, what we’re going to do today is get you setup with the [INSERT
            PRODUCT NAME] benefit, which will solve both of those problems.
          </li>
          <li>
            <strong>Capital Legacy Benefit</strong> Capital Legacy is is a
            hybrid solution because it has two parts: Life Insurance & ROTH IRA
            accumulations and savings.
          </li>
          <li>
            <strong>Pay for Only the Life Insurance You Need</strong> the Life
            Insurance portion is what protects you and your family. It provides
            you ONLY with the life insurance you need without paying for
            coverage you don’t. Makes sense, right? It also doesn’t go up in
            price like FEGLI.
          </li>
          <li>
            <strong>Save More Money</strong> The money you save on life
            insurance allows you to save even more money. The best part is that
            the money you save between now and retirement will play a
            significant role in your retirement!
          </li>
          <li>
            <strong>Cash Is King</strong> At retirement you no longer pay for
            life insurance because you will have accumulated enough savings.
            You’ve heard of Dave Ramsey, correct? Buy Term and Invest the
            Difference? This is exactly what he is referring to.
          </li>
          <li>
            <strong>Money Puts You Back in Control</strong> It’s the smartest
            way for you to solve the Life Insurance needs, rainy day fund, and
            Emergency Savings needs while also solving your cash and life
            insurance needs for tomorrow. Also remember the Roth IRA savings are
            tax free; the tax-free money will be very important to you at
            retirement and offsetting the tax liability.
          </li>
          <li>
            <strong>Here’s How It Works</strong> Many federal / postal employees
            start this benefit with an allotment of as much as $150. What we're
            going to get you set up at today is $110-$140.
            <ol type="a" style={{ marginTop: "10px" }}>
              <li>
                <strong>First Year</strong> [$AMOUNT] goes towards the life
                insurance locking in your coverage and locking in your rate. $5
                goes towards the Roth IRA, and $1 goes to the bank that handles
                the transfer of your money from your paycheck to your Capital
                Legacy benefits.{" "}
              </li>
              <li>
                <strong>Second Year</strong> Beginning with the 2nd year, this
                splits to half of the first year amount, and the rest goes to
                your Roth IRA and $1 continues to go to the bank.
              </li>
              <li>
                <strong>Only the Life Insurance You Need</strong> Capital Legacy
                provides you with a Level Death benefit for the next 10 years.
                Starting the 11th year, your death benefit will slowly start
                decreasing. This is when you start saving more money. The money
                you save will automatically be added to your savings account.
              </li>
              <li>
                <strong>Save More Money</strong> At the beginning of year 11th
                year, you will receive back every dime paid into the policy for
                your first year. This money is credited to your ROTH. The money
                you save from the decreasing term will automatically start being
                added to the ROTH. Starting in year 11, your savings account
                will grow significantly.
              </li>
              <li>
                <strong>Furlough Rider</strong> you will have Furlough
                Protection. If you are told your position is being furloughed,
                you will have no premiums due for the first 6 months. This is
                HUGE
              </li>
              <li>
                <strong>Rainy Day Fund/Emergency Savings</strong> The best part
                of it all is that you are building a nest egg and safety net for
                you and your family.{" "}
                <strong>This money puts YOU BACK IN CONTROL.</strong> This money
                will be available to you between now and retirement. You can get
                cash penalty-free. Eliminates the future need for TSP loans,
                etc.
              </li>
              <li>
                <strong>No Risk Investment</strong> Capital Legacy has a
                Guaranteed interest rate. So regardless of what’s going on with
                the economy, you will always make at least ___% interest on your
                money for the rest of your life. This program is currently
                growing at [Current Interest Rate%], and it has grown as high as
                8 ¾ % but has never been less than 4%. This gives you a great
                sense of security knowing that no matter what the stock markets
                are doing, you’ll always be making at least [GUARANTEED RATE]%.
              </li>
              <li>
                <strong>Living Benefits</strong> There are also additional
                benefits attached to Capital Legacy at no cost to you for cases
                of serious illnesses such as cancer, terminal illnesses, etc.
                These “no cost” accelerated living benefits can prevent serious
                financial hardship.
              </li>
            </ol>
          </li>
          <li>
            <strong>The Close</strong>
            <ol type="a" style={{ marginTop: "10px" }}>
              <li>
                Based on your age and years of service, we’ll get everything
                setup at [$AMOUNT] to at least get the ball rolling. We can
                always add more down the road if you’d like, however, the most
                important part of Capital Legacy is that it gets started.
              </li>
              <li>
                Do you have any questions about the program and how it works?
              </li>
              <li>
                Remember, based on what we saw from your paycheck, we know that
                we need to slide over the additional TSP 1% you are contributing
                to your TSP, plus make a slight adjustment to your FEDERAL TAX
                withholding.
              </li>
              <li>I’ll walk you through how to set everything up.</li>
            </ol>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default Summary;
